import { useRef, useState, useEffect } from 'react'
import IconMinus from '@icons/Minus'
import IconPlusBig from '@icons/PlusBig'
import { PROPERTY_FEATURE } from '@constants/property'
import { Detail, DetailHeading } from '../PropertyDetails.styled'
import * as S from './PropertyFeatures.styled'

const PropertyFeatures = ({ features }) => {
  if (!features || features.length === 0) return null
  const [isOpen, setOpen] = useState(false)
  const [height, setHeight] = useState({
    min: 0,
    max: 0,
  })
  const [hidden, setHidden] = useState(false)
  const featuresElm = useRef(null)

  const toggleDescription = () => {
    setOpen(!isOpen)
  }

  useEffect(() => {
    setHeight({ max: featuresElm.current?.scrollHeight })
    setHidden(true)
  }, [])

  useEffect(() => {
    setTimeout(() => {
      setHeight({ ...height, min: featuresElm.current?.scrollHeight })
    }, 100)
  }, [hidden])

  return (
    <Detail>
      <DetailHeading>Property Features</DetailHeading>
      <S.PropertyFeatures
        ref={featuresElm}
        style={{
          height: isOpen ? height.max : height.min,
        }}
      >
        {features.map((feature, key) => (
          <S.PropertyFeature
            key={`feature-${key}`}
            hidden={key > 3 && hidden && !isOpen}
          >
            {['livingAreas', 'toilets'].includes(feature.name)
              ? `${PROPERTY_FEATURE[feature.name] || feature.name}: ${
                  feature.value
                }`
              : `${PROPERTY_FEATURE[feature.name] || feature.name}`}
          </S.PropertyFeature>
        ))}
      </S.PropertyFeatures>
      {features.length > 4 && (
        <S.Readmore onClick={toggleDescription} open={isOpen}>
          {isOpen ? (
            <>
              Read less <IconMinus />
            </>
          ) : (
            <>
              Read more <IconPlusBig />
            </>
          )}
        </S.Readmore>
      )}
    </Detail>
  )
}

export default PropertyFeatures
